module.exports = __webpack_public_path__ + "static/media/maestro.256b1137.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/TransactionsTable/images/maestro.svg
// module id = 654
// module chunks = 0